import { Theme, css } from '@emotion/react';

export const tooltip = ({ colors, spacing, typography }: Theme) => css`
  background-color: ${colors.backgroundDarkest};
  color: ${colors.textWhite};
  font-size: ${typography.pxToRem(10)};
  padding: ${spacing(1)}px;
`;

export const tooltipArrow = ({ colors }: Theme) => css`
  color: ${colors.backgroundDarkest};
`;
